if ($(".homepage-products-heading-2").length) {
  $(".homepage-products-heading-2").prepend("<span>" + translation('obleceniProZavodText') + "</span>");
  $(".homepage-products-heading-2").append("<p>" + translation('obleceniProZavodBenefity') + "</p>");
  $(".homepage-products-heading-2 + .products").after('<div class="btnWrap"> </div>');
}

if ($(".homepage-products-heading-4").length) {
  $(".homepage-products-heading-4").prepend("<span>" + translation('ledniKrasobrusleText') + "</span>");
  $(".homepage-products-heading-4").append("<p>" + translation('ledniKrasobrusleBenefity') + "</p>");
  $(".homepage-products-heading-4 + .products").after('<div class="btnWrap"></div>');
}




$(document).on("click", ".in-index .servis a.btn-primary", function (e) {
  e.preventDefault();
  const $contacts = $('<ul class="contacts popup-contacts"></ul>');
  $contacts.append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $contacts.append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  $contacts.find(".tel a").after("<span>" + translation('telefonInfo') + "</span>");
  $contacts.find(".mail a").after("<span>" + translation('mailInfo') + "</span>");
  $.colorbox({
    html: $('<div class="orderPopup"></div>').append("<h2>"+translation('objednatbrouseni')+"</h2>", $contacts),
    width: "500px",
    maxWidth: "90%"
  });
});
